import { defineMessages } from 'react-intl';

export const addToBasketLayerMessages = defineMessages({
  errorMessage: {
    id: 'addToBasketLayer.error.message',
    defaultMessage: 'Produkt konnte nicht geladen werden...',
  },
  errorButtonText: {
    id: 'addToBasketLayer.error.button.text',
    defaultMessage: 'Erneut versuchen',
  },
});
